export default {
	name: 'booksSeries',
	data() {
		return {
			getData: {},
			booksSeries: [],
			booksSeriesList: [],
			saveData: {},
			seriesID: 0,
			getbooksSeriesList: {},
			pageIndex: 1,
			pageRows: 15,
			count: 0,
			Edit: '',
			fileName: '',
			file: '',
			img: '',
			booksSeriesListName: '',
			booksSeriesListDesc: '',
			type: '',
			booksSeriesListID: 0
		};
	},
	created() {
		this.getData = () => {
			this.$request.request({
				url: 'books/booksSeries',
				data: {},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.booksSeries = res.booksSeries;
					this.seriesID = this.booksSeries[0].seriesID;
					this.getbooksSeriesList();
				}
			});
		}
		this.getbooksSeriesList = () => {
			this.$request.request({
				url: 'books/getbooksSeriesList',
				data: {
					seriesID: this.seriesID,
					pageIndex: this.pageIndex,
					pageCount: this.pageRows
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.booksSeriesList = res.booksSeriesList;
					this.count = res.count;
				}
			});
		}

		this.saveData = () => {
			let param = new FormData()
			param.append('booksSeriesListID', this.booksSeriesListID);
			param.append('booksSeriesListDesc', this.booksSeriesListDesc);
			param.append('booksSeriesListName', this.booksSeriesListName);
			param.append('seriesID', this.seriesID);
			param.append('type', this.type);
			param.append('file', this.file);
			this.$request.upLoadFile({
				url: 'books/savebooksSeries',
				data: param,
				method: 'post'
			}).then(res => {
				this.Edit = '';
				this.getbooksSeriesList();
				this.$uil.showMessage({
					text: res.message
				});
			});
		}
	},
	methods: {
		addSeries() {
			this.booksSeriesListID = 0;
			this.booksSeriesListDesc = "";
			this.booksSeriesListName = '';
			this.type = 'add';
			this.fileName='';
			this.Edit = 'add';
		},
		updateSeries(i) {
			this.seriesID = i.seriesID;
			this.booksSeriesListID = i.booksSeriesListID;
			this.booksSeriesListDesc = i.booksSeriesListDesc;
			this.booksSeriesListName = i.booksSeriesListName;
			this.type = 'update';
			this.Edit = 'update';
			this.fileName='';
		},
		removebooksSeries(i) {
			 
			this.booksSeriesListID = i.booksSeriesListID;
			this.booksSeriesListDesc = i.booksSeriesListDesc;
			this.booksSeriesListName = i.booksSeriesListName;
			this.type = 'del';
			this.$uil.showMessage({
				text: '确定删除',
				type: 'confirm',
				ok: () => this.saveData()
			});
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;
			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getbooksSeriesList();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getbooksSeriesList();
		},
		selectFile(e) {
			let camear = this.$refs.camear;
			camear.click();
			let img = this.$refs.camear;
			let that = this;
			camear.onchange = function() {
				that.file = this.files[0];
				that.fileName = this.files[0].name;
				//if(this.checkFile.length>0) return;
				var reader = new FileReader();
				reader.readAsDataURL(this.files[0]);
				reader.onload = function() {
					that.img = this.result;
				};
			};
		}
	},
	computed: {
		checkCustomer() {
			return this.$uil.checkPhone(this.CustomerPhone) && this.$uil.checkchinese(this.CustomerName, 2, 6);
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		checkFile() {
			if (this.fileName == '') return '';
			let index = this.fileName.lastIndexOf('.');
			if (index == -1) return '格式错误';
			let ext = this.fileName.substring(index + 1);
			if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) == -1)
				return '格式错误';
			else
				return '';
		}
	},
	activated() {
		this.getData();
	}
}
